import React from 'react'
import { ExplicitPageView } from '../../../application/analytics'
import { selectAuthError, selectAuthPending } from '../../../application/features/auth/selectors'
import { useAppSelector } from '../../../application/store'
import { changeTitle } from '../../../containers/changeTitle'
import { ConfirmCodeForm, ConfirmCodeValues } from '../Forms/ConfirmCodeForm'

interface Props {
  submit: (details: ConfirmCodeValues) => Promise<void>
  resendCode: () => Promise<void>
  goToSignIn: () => void
  email: string
}

export const ConfirmCodePage: React.FC<Props> = ({ submit, resendCode, goToSignIn, email }) => {
  changeTitle('Confirm Code')
  const error = useAppSelector(selectAuthError)
  const authActionPending = useAppSelector(selectAuthPending)

  const onSubmit = async (values: ConfirmCodeValues) => {
    await submit(values)
  }

  const onResendCode = async () => {
    await resendCode()
  }

  return (
    <>
      <ExplicitPageView page="/confirm-code" />
      <ConfirmCodeForm
        submit={onSubmit}
        resendCode={onResendCode}
        goToSignIn={goToSignIn}
        email={email}
        error={error?.message}
        pending={authActionPending}
      />
    </>
  )
}
